import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import React from 'react';

// TODO: handle a pickup object with tracking number and selected packages
const PickUpInfos = ({ formData, handleFormChange, formError }) => {
  const handleTrackingNumberChange = (value) => {
    if (value?.length > 20) {
      return;
    }
    handleFormChange({ key: 'trackingNumber', value });
  };

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          mb: 2,
        }}
      >
        <Box>
          <Button
            variant="text"
            size="small"
            sx={{ fontSize: '12px' }}
            startIcon={<OpenInNewIcon sx={{ fontSize: 'small' }} />}
            onClick={() =>
              window.open(
                'https://expedier.dpd.fr/collection-request/create',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            DPD
          </Button>
          <Button
            variant="text"
            size="small"
            sx={{ fontSize: '12px' }}
            startIcon={<OpenInNewIcon sx={{ fontSize: 'small' }} />}
            onClick={() =>
              window.open(
                'https://www.laposte.fr/expedition-bal/formulaire',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            Colissimo
          </Button>
          <Button
            variant="text"
            size="small"
            sx={{ fontSize: '12px' }}
            startIcon={<OpenInNewIcon sx={{ fontSize: 'small' }} />}
            onClick={() =>
              window.open(
                'https://wwwapps.ups.com/pickup/schedule?loc=fr_FR',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            UPS
          </Button>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
          size="small"
          error={Boolean(formError.trackingNumber)}
          helperText={formError.trackingNumber}
          label={`Numéro de tracking`}
          value={formData.trackingNumber}
          sx={{ width: '300px' }}
          onChange={(e) => handleTrackingNumberChange(e.target.value)}
        />
        <FormControl
          fullWidth
          size="small"
          error={Boolean(formError.carrier)}
          helperText={formError.carrier}
        >
          <InputLabel>Transporteur</InputLabel>
          <Select
            value={formData.carrier}
            onChange={(e) =>
              handleFormChange({ key: 'carrier', value: e.target.value })
            }
            label="Transporteur"
            size="small"
            sx={{ width: '200px' }}
          >
            <MenuItem value="DPD">DPD</MenuItem>
            <MenuItem value="COLISSIMO">Colissimo</MenuItem>
            <MenuItem value="UPS">UPS</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default PickUpInfos;
